<template>
  <div class="chart">
    <div class="no-data" v-show="noChartData && !loading">まだテストの受験記録がありません</div>
    <el-tooltip
      class="item"
      :open-delay="800"
      effect="dark"
      content="テストスコアの時系列推移を表しています"
      placement="left"
    >
      <chartist
        ratio="ct-chart"
        style
        :style="`${this.noChartData ? 'filter: blur(3px)' : ''}`"
        type="Line"
        :data="chartData"
        :options="chartOptions"
      ></chartist>
    </el-tooltip>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-chartist"));
import { db } from "@/plugins/firebase";
export default {
  data() {
    return {
      rankingLoading: false,
      myRanking: null,
      othersRanking: null,
      totalRanking: null,
      loading: true,
      tabIndex: 0,
      noChartData: true,
      results: [],
      chartData: {
        series: [[]],
        labels: [[]]
      },

      chartOptions: {
        axisX: {
          labelInterpolationFnc: function(value, index, label) {
            if (label.length > 20 && label.length <= 40) {
              return index % 2 === 0 ? value : null;
            } else if (label.length > 40) {
              return index % 10 === 0 ? value : null;
            } else {
              return String(parseInt(value) + 1) + "回目";
            }
          }
        },
        lineSmooth: this.$chartist.Interpolation.simple({
          divisor: 2,
          fillHoles: false
        }),
        height: "380px",
        chartPadding: {
          left: 10,
          top: 30,
          right: 10,
          bottom: 30
        }
      }
    };
  },
  async mounted() {
    let results = [];
    try {
      const resultRef = await db
        .collection("users")
        .doc(this.$store.state.auth.user.uid)
        .collection("TestResults")
        .orderBy("date", "asc")
        .get();
      resultRef.forEach(doc => {
        results.push(doc.data());
      });
      this.results = results;
      if (results.length > 0) {
        this.noChartData = false;
        const chartData = results.map(result => result.totalScore);

        this.chartData = {
          series: [chartData],
          labels: chartData.map((s, index) => {
            return index.toString();
          })
        };
      } else {
        this.chartData = {
          series: [[4213, 5355, 7543, 7200, 9024, 12400]],
          labels: [["1", "2", "3", "4", "5", "6"]]
        };
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.no-data {
  position: absolute;
  top: 170px;
  right: 0;
  left: 0;
  padding: 10px 40px;
  width: 256px;
  height: 24px;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  z-index: 30;
  font-weight: bold;
}
.legend {
  bottom: -35px;
  left: 50%;
  font-weight: 600;
  z-index: 50;
  font-size: 1rem;
}
.chart {
  min-height: 375px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
</style>
